module.exports = __webpack_public_path__ + "static/scale-model-of-lafayette-science-museum-in-lafayette-louisiana-0895ef4459a2c1562abdf9dceb307c0f.png";